module.exports = __webpack_public_path__ + "img/tips_tag.1d7e82f5.svg";